import createActionType from "../utils/createActionType";

const MODULE = "authentication";

export const IS_LOGGING_IN = createActionType(MODULE, "setIsLoggingIn");
export const IS_AUTHENTICATED = createActionType(MODULE, "setIsAuthenticated");
export const IS_CHECKING_AUTH = createActionType(MODULE, "setIsCheckingAuth");
export const SET_ERROR_MESSAGE = createActionType(MODULE, "setErrorMessage");
export const RESET_APP = createActionType(MODULE, "resetApp");
